/**
 * Reading data/navi/naviLinkItem.json, for the desktop and mobile menus alike.
 */

/** A group with one entry named like the group is a plain link, not a dropdown ("Overview"). */
export const isPlainLink = (item) => item.list.length === 1 && item.title === item.list[0].text;

/**
 * Whether `url` is the page the visitor is on: an internal path that matches,
 * and every query param the entry sets (Solutions: ?persona=sales) equal to
 * the visitor's — while an entry that sets none (Overview) is not the page
 * when a persona is on. The hash is left aside.
 */
export const isCurrentPage = (pathname, url, search = '') => {
    if (/^https?:/.test(url)) return false;
    const [path, query = ''] = url.split('#')[0].split('?');
    if (pathname !== path) return false;
    const wanted = new URLSearchParams(query);
    const actual = new URLSearchParams(search);
    if (![...wanted].every(([key, value]) => actual.get(key) === value)) return false;
    return wanted.has('persona') || !actual.has('persona');
};
